<template>
  <div :contenteditable="editType" @input="handleInput"></div>
</template>

<script>
export default {
  name: 'Editable',
  props: {
    value: String,
    allowhtml: Boolean
  },
  data () {
    return {}
  },
  computed: {
    editType () {
      return this.allowhtml ? true : 'plaintext-only'
    }
  },
  watch: {
    value (val) {
      if (this.$el.innerHTML !== val) {
        this.$el.innerHTML = val || ''
      }
    }
  },
  mounted () {
    this.$el.innerHTML = this.value || ''
  },
  methods: {
    handleInput () {
      this.$emit('input', this.$el.innerHTML)
    }
  }
}
</script>